
import { NgModule } from '@angular/core';
import { SharedModule } from '../../../core/modules/shared.module';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from '../../../_guards/auth.guard';
import { RoleGuard } from '../../../_guards/role.guard';
import { KeywordListComponent } from './keyword-list.component';

const routes: Routes = [
    {
        path: 'keyword-list',
        component: KeywordListComponent,
        data: {
            permission: {
                only: ['role1', 'role2']
            }
        },
        canActivate: [AuthGuard, RoleGuard]
    }
];

@NgModule({
    imports: [
        SharedModule,
        RouterModule.forChild(routes)
    ],
    declarations: [
        KeywordListComponent
    ],
    entryComponents: [],
    providers: [
        AuthGuard, RoleGuard
    ]
})
export class KeywordListModule {
}



// WEBPACK FOOTER //
// C:/Users/Lenovo/Desktop/bigadviceadminSkeleton/src/app/main/content/keyword-list/keyword-list.module.ts